module.exports = __webpack_public_path__ + "img/theMill.e240ff8a.jpg";